module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/close-6948956c4db02d1c4d8c25e1c57c8731.svg";